module.exports = __webpack_public_path__ + "img/20200507_131454.d549085e.jpg";